module.exports = __webpack_public_path__ + "static/img/quan_5.914e2537.png";